import React from "react";

import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import { COLOR_KICK_BLUE } from "~/shared/sharedConstants";

import { kickLightPink, kickNavy } from "~/shared/styles/baseStyles";

import imgFruitPunch from "~assets/images/flavors/tropical-fruit-medley-flavor.png";

function StyledButton({ children, style, ...props }) {
  return (
    <Button
      color="primary"
      size="large"
      style={{
        backgroundColor: COLOR_KICK_BLUE,
        color: "white",
        marginTop: "10px",
        width: "300px",
        ...style,
      }}
      {...props}
    >
      {children}
    </Button>
  );
}

export function FlavoredBBsUpsellCard({ onClick }) {
  return (
    <Card
      style={{
        border: "1px solid gray",
        borderRadius: "6px",
        marginBottom: "20px",
        paddingBottom: "20px",
        width: "350px",
        display: "flex",
        alignItems: "center",
        textAlign: "center",
        flexDirection: "column",
        backgroundColor: "white",
      }}
    >
      <p
        style={{
          fontSize: "20px",
          fontFamily: "Spectral-Bold",
          color: kickNavy,
          marginTop: "20px",
          marginBottom: "16px",
        }}
      >
        — Now Available —
      </p>
      <p
        style={{
          fontSize: "16px",
          fontFamily: "BasisGrotesquePro-Bold",
          color: kickNavy,
          marginBottom: "8px",
          textAlign: "center",
        }}
      >
        Faster & Stronger Beta-Blockers Mints:
        <br />
        5x Faster in Three Great Flavors
      </p>
      <img
        src={imgFruitPunch}
        alt="Fruit Punch Flavored Troches"
        style={{
          height: "152px",
          position: "relative",
        }}
      />
      <p
        style={{
          fontSize: "16px",
          fontFamily: "BasisGrotesquePro-Regular",
          color: kickNavy,
          marginBottom: "16px",
          textAlign: "center",
          padding: "0 20px",
        }}
      >
        Our new compounded sublingual mints start working in just 10 minutes
      </p>
      <div
        style={{
          width: "88%",
          borderRadius: "6px",
          padding: "12px 10px 6px 10px",
          marginBottom: "24px",
          backgroundColor: kickLightPink,
          fontFamily: "BasisGrotesquePro-Regular",
        }}
      >
        <ul
          style={{
            fontFamily: "BasisGrotesquePro-Regular",
            textAlign: "left",
            margin: "0",
            paddingLeft: "20px",
          }}
        >
          <li>Dissolves under tongue in 60 seconds</li>
          <li>Same trusted meds, 20% stronger dosage</li>
          <li>Faster-acting for unexpected moments</li>
        </ul>
        <p style={{ fontFamily: "BasisGrotesquePro-Bold", marginTop: "10px" }}>
          Start visit below to order today
        </p>
      </div>
      <StyledButton
        onClick={onClick}
        style={{
          backgroundColor: COLOR_KICK_BLUE,
        }}
      >
        Start Visit&nbsp;
        <NavigateNextIcon />
      </StyledButton>
    </Card>
  );
}
